export default __webpack_public_path__ + "static/media/loginbg5.4b43d330.jpg";